import { UserRole } from '@lmc/ts-common'

export const isGroupUser = (
  role: UserRole | string | null | undefined
): boolean => role === UserRole.groupAdmin || role === UserRole.groupManager
